import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import WebApp from '@twa-dev/sdk'

type GamesInfoProps = {
  id: number
  title: string
  img: string
  hours?: string
}

export const GamesInfo = (props: GamesInfoProps) => {
  const userLang = useUnit($userLanguage)
  const { id, title, hours } = props
  const { classes } = useStyles()
  const units = lang[userLang].pages.units

  const handleRedirect = () => {
    WebApp.openLink(`https://store.steampowered.com/app/${id}`)
  }

  return (
    <div className={classes.listItem} onClick={handleRedirect} key={id}>
      <div className={classes.gameInfo}>
        <div className={classes.gameIcon}>
          <img
            crossOrigin="anonymous"
            src={`https://steamcdn-a.akamaihd.net/steam/apps/${id}/header.jpg`}
            alt={title}
          />
        </div>
        <div className={classes.gameName}>
          <p>{title}</p>
        </div>
      </div>
      {hours && (
        <div className={classes.gameTime}>
          {hours} {units.hours}
        </div>
      )}
    </div>
  )
}
